/* ============================================
   BULK ORDER TABLE v2 - JavaScript
   Color selector + Size table + Sticky footer
   ============================================ */

(function () {
  'use strict';

  function init() {
    const wrapper     = document.getElementById('bulk-order-wrapper');
    if (!wrapper) return;

    // Κρύβει native elements για B2B
    if (window.isB2BCustomer) {
      const style = document.createElement('style');
      style.textContent = `
        .product-form__input--swatch,
        .product-form__input--pill,
        .quantity,
        .quantity__button,
        .quantity__input,
        .product-form__quantity {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    const dataEl      = document.getElementById('bulk-variants-data');
    const colorBtns   = document.getElementById('bulk-color-buttons');
    const tbody       = document.getElementById('bulk-tbody');
    const addBtn      = document.getElementById('bulk-add-btn');
    const msgBox      = document.getElementById('bulk-message');
    const totalQtyEl  = document.getElementById('bulk-total-qty');
    const totalPriceEl= document.getElementById('bulk-total-price');

    if (!dataEl || !tbody || !addBtn) return;

    // ── Parse variant data ───────────────────
    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch(e) {
      console.error('[Bulk Order] Failed to parse variant data', e);
      return;
    }

    // ── State ────────────────────────────────
    let selectedColor = null;
    let quantities    = {}; // variantId → qty

    // ── Get unique colors ────────────────────
    const colors = [...new Set(variants.map(v => v.color))];
    selectedColor = colors[0] || null;

    // ── Color name → hex map ─────────────────
    const colorMap = {
      'red': '#e53e3e', 'κόκκινο': '#e53e3e', 'kokkino': '#e53e3e',
      'blue': '#3b82f6', 'μπλε': '#3b82f6', 'mple': '#3b82f6',
      'navy': '#1e3a5f', 'ναυτικό': '#1e3a5f',
      'green': '#22c55e', 'πράσινο': '#22c55e',
      'black': '#1a1a1a', 'μαύρο': '#1a1a1a', 'mavro': '#1a1a1a',
      'white': '#ffffff', 'άσπρο': '#f8f8f8', 'aspro': '#f8f8f8', 'λευκό': '#f8f8f8',
      'gray': '#6b7280', 'grey': '#6b7280', 'γκρι': '#6b7280', 'gkri': '#6b7280',
      'yellow': '#eab308', 'κίτρινο': '#eab308',
      'orange': '#f97316', 'πορτοκαλί': '#f97316',
      'pink': '#ec4899', 'ροζ': '#ec4899', 'roz': '#ec4899',
      'purple': '#a855f7', 'μωβ': '#a855f7', 'mov': '#a855f7',
      'brown': '#92400e', 'καφέ': '#92400e', 'kafe': '#92400e',
      'beige': '#d4b896', 'μπεζ': '#d4b896',
      'turquoise': '#06b6d4', 'τιρκουάζ': '#06b6d4',
      'ochre': '#c8920a', 'ώχρα': '#c8920a',
      'khaki': '#8b8b5a', 'χακί': '#8b8b5a',
      'burgundy': '#7f1d1d', 'μπορντό': '#7f1d1d',
      'coral': '#fb7185', 'mint': '#6ee7b7',
      'gold': '#f59e0b', 'χρυσό': '#f59e0b',
      'silver': '#9ca3af', 'ασημί': '#9ca3af',
    };

    function getSwatchColor(colorName) {
      const key = colorName.toLowerCase().trim();
      return colorMap[key] || '#cbd5e1';
    }

    // ── Color button clicks ──────────────────
    if (colorBtns) {
      const availableColors = colors.filter(color =>
        variants.some(v => v.color === color && v.available)
      );

      if (!availableColors.includes(selectedColor)) {
        selectedColor = availableColors[0] || null;
      }

      colorBtns.innerHTML = '';
      availableColors.forEach((color, i) => {
        const btn = document.createElement('button');
        btn.className = 'bulk-color-btn' + (i === 0 ? ' bulk-color-btn--active' : '');
        btn.dataset.color = color;
        btn.type = 'button';
        const swatchColor = getSwatchColor(color);
        btn.innerHTML = `<span class="bulk-color-swatch" style="background:${swatchColor}"></span><span>${escHtml(color)}</span>`;
        colorBtns.appendChild(btn);
      });

      colorBtns.addEventListener('click', function(e) {
        const btn = e.target.closest('.bulk-color-btn');
        if (!btn) return;

        const color = btn.dataset.color;
        if (color === selectedColor) return;

        selectedColor = color;

        colorBtns.querySelectorAll('.bulk-color-btn').forEach(b => {
          b.classList.toggle('bulk-color-btn--active', b.dataset.color === color);
        });

        // Αλλαγή κύριας φωτογραφίας για το επιλεγμένο χρώμα
        const colorVariant = variants.find(v => v.color === color);
        if (colorVariant && colorVariant.image) {
          const mainImage = document.querySelector('.product__media img, .product-media-container img');
          if (mainImage) {
            const highResUrl = colorVariant.image.replace(/width=\d+/, 'width=1200');
            mainImage.src = highResUrl;
            mainImage.srcset = highResUrl;
          }
        }

        renderTable();
        updateSummary();
      });
    }

    // ── Render table for selected color ──────
    function renderTable() {
      const colorVariants = variants.filter(v => v.color === selectedColor);
      tbody.innerHTML = '';
      hideMultivariants();

      colorVariants.forEach(variant => {
        if (!variant.available) return;
        const qty     = quantities[variant.id] || 0;
        const isOut   = !variant.available;
        const maxQty  = variant.managed === 'shopify' ? variant.stock : 9999;

        const tr = document.createElement('tr');
        tr.className = 'bulk-row' + (isOut ? ' bulk-row--soldout' : '') + (qty > 0 ? ' bulk-row--selected' : '');
        tr.dataset.variantId = variant.id;
        tr.dataset.price     = variant.price;
        tr.dataset.max       = maxQty;

        const imgHtml = variant.image
          ? `<img src="${variant.image}" alt="${escHtml(variant.size)}" class="bulk-variant-img" loading="lazy">`
          : `<div class="bulk-no-img"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21,15 16,10 5,21"/></svg></div>`;

        let stockText = '';
        let stockClass = '';
        if (variant.managed === 'shopify') {
          if (variant.stock > 0) {
            stockClass = variant.stock <= 5 ? 'qty-stock-badge--low' : '';
            stockText  = variant.stock + ' In stock';
          } else {
            stockClass = 'qty-stock-badge--out';
            stockText  = 'Out of stock';
          }
        } else {
          stockText = 'In stock';
        }

        const qtyHtml = isOut
          ? `<span class="soldout-dash">—</span>`
          : `<div class="qty-wrapper">
              <button class="qty-btn qty-minus" type="button" aria-label="Μείωση" ${qty <= 0 ? 'disabled' : ''}>−</button>
              <input type="number" class="qty-input" value="${qty}" min="0" max="${maxQty}" aria-label="Ποσότητα">
              <button class="qty-btn qty-plus" type="button" aria-label="Αύξηση">+</button>
            </div>`;

        const calcPrice = formatMoney(variant.price * qty);
        const compareHtml = variant.compare_price > variant.price
          ? `<span class="bulk-compare-price">${formatMoney(variant.compare_price)}</span>`
          : '';

        tr.innerHTML = `
          <td class="td-image">${imgHtml}</td>
          <td class="td-size"><span class="bulk-size-name">${escHtml(variant.size)}</span></td>
          <td class="td-qty">
            <span class="qty-label">Quantity</span>
            ${qtyHtml}
            <span class="qty-stock-badge ${stockClass}">${stockText}</span>
          </td>
          <td class="td-price td-stock-hidden">
            <span class="price-label">Price</span>
            <span class="bulk-price" data-base-price="${variant.price}">${qty > 0 ? calcPrice : formatMoney(variant.price)}</span>
            ${compareHtml}
          </td>
        `;

        tbody.appendChild(tr);
      });
    }

    // ── Table interactions ────────────────────
    tbody.addEventListener('click', function(e) {
      const btn = e.target.closest('.qty-btn');
      if (!btn) return;

      const row   = btn.closest('.bulk-row');
      const input = row.querySelector('.qty-input');
      if (!input) return;

      const variantId = row.dataset.variantId;
      const max       = parseInt(row.dataset.max, 10) || 9999;
      let current     = parseInt(input.value, 10) || 0;

      if (btn.classList.contains('qty-plus')) {
        if (current < max) {
          current++;
        } else {
          showMessage('Μέγιστη διαθέσιμη ποσότητα: ' + max + ' τεμ.', 'error', 2500);
          return;
        }
      } else {
        if (current > 0) current--;
        else return;
      }

      input.value = current;
      quantities[variantId] = current;
      updateRowState(row, input, current);
      updateSummary();
    });

    tbody.addEventListener('input', function(e) {
      const input = e.target.closest('.qty-input');
      if (!input) return;

      const row       = input.closest('.bulk-row');
      const variantId = row.dataset.variantId;
      const max       = parseInt(row.dataset.max, 10) || 9999;
      let val         = parseInt(input.value, 10);

      if (isNaN(val) || val < 0) { val = 0; input.value = 0; }
      if (val > max) { val = max; input.value = max; showMessage('Μέγιστη ποσότητα: ' + max, 'error', 2000); }

      quantities[variantId] = val;
      updateRowState(row, input, val);
      updateSummary();
    });

    function updateRowState(row, input, qty) {
      row.classList.toggle('bulk-row--selected', qty > 0);
      const minusBtn = row.querySelector('.qty-minus');
      if (minusBtn) minusBtn.disabled = qty <= 0;

      const priceEl   = row.querySelector('.bulk-price');
      const basePrice = parseInt(row.dataset.price, 10);
      if (priceEl && basePrice) {
        priceEl.textContent = formatMoney(qty > 0 ? basePrice * qty : basePrice);
      }
    }

    // ── Summary ───────────────────────────────
    function updateSummary() {
      let totalQty   = 0;
      let totalPrice = 0;

      Object.entries(quantities).forEach(([id, qty]) => {
        if (qty <= 0) return;
        const variant = variants.find(v => v.id == id);
        if (!variant) return;
        totalQty   += qty;
        totalPrice += qty * variant.price;
      });

      if (totalQtyEl)   totalQtyEl.textContent = totalQty;
      if (totalPriceEl) totalPriceEl.textContent = formatMoney(totalPrice);
      addBtn.disabled = totalQty === 0;
    }

    // ── Update cart count στο bulk-cart-btn ──
    function updateCartCount() {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const countEl = document.getElementById('bulk-cart-count');
          if (countEl) countEl.textContent = cart.item_count;
          const totalEl = document.getElementById('bulk-cart-total');
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        })
        .catch(() => {});
    }

    // Φόρτωσε τον αριθμό αμέσως
    updateCartCount();

    // ── Add to Cart ───────────────────────────
    addBtn.addEventListener('click', async function() {
      const items = Object.entries(quantities)
        .filter(([id, qty]) => qty > 0)
        .map(([id, qty]) => ({ id: parseInt(id, 10), quantity: qty }));

      if (items.length === 0) return;

      setLoading(true);
      hideMessage();

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description || 'Σφάλμα κατά την προσθήκη.');
        }

        showMessage('✓ Τα προϊόντα προστέθηκαν στο καλάθι!', 'success', 4000);

        items.forEach(({id, quantity}) => {
          const v = variants.find(v => v.id == id);
          if (v && v.managed === 'shopify') {
            v.stock = Math.max(0, v.stock - quantity);
            v.available = v.stock > 0;
          }
        });

        quantities = {};
        renderTable();
        updateSummary();
        updateCartCount();
        refreshCartCount();
        openCartDrawer();

      } catch(err) {
        showMessage('Σφάλμα: ' + err.message, 'error', 5000);
      } finally {
        setLoading(false);
      }
    });

    // ── Helpers ───────────────────────────────
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('el-GR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
    }

    function escHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function setLoading(loading) {
      if (loading) {
        addBtn.disabled = true;
        addBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:bulk-spin 0.8s linear infinite"><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg> Γίνεται προσθήκη...`;
      } else {
        addBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"></path></svg> Προσθήκη στο Καλάθι`;
        updateSummary();
      }
    }

    function showMessage(text, type, duration) {
      msgBox.textContent  = text;
      msgBox.className    = 'bulk-message bulk-message--' + type;
      if (duration) setTimeout(hideMessage, duration);
    }

    function hideMessage() {
      msgBox.className = 'bulk-message';
      msgBox.textContent = '';
    }

    function refreshCartCount() {
      fetch('/?sections=cart-icon-bubble')
        .then(r => r.json())
        .then(data => {
          if (data['cart-icon-bubble']) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
            const newBubble = doc.querySelector('.cart-count-bubble');
            const cartIcon  = document.querySelector('#cart-icon-bubble');
            if (cartIcon) {
              const oldBubble = cartIcon.querySelector('.cart-count-bubble');
              if (oldBubble) oldBubble.remove();
              if (newBubble) cartIcon.appendChild(newBubble);
            }
          }
        })
        .catch(() => {});
    }

    function openCartDrawer() {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        const cartIcon = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (cartIcon) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.classList.contains('active')) {
            cartIcon.click();
            setTimeout(() => cartIcon.click(), 100);
          }
        }

        fetch('/?section_id=cart-drawer').then(r => r.text()).then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }).catch(() => {});

      }).catch(() => {});
    }

    // ── Spin animation ────────────────────────
    const style = document.createElement('style');
    style.textContent = '@keyframes bulk-spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }';
    document.head.appendChild(style);

    // ── Sticky footer - μετακίνηση στο body ──
    const stickyFooter = document.getElementById('bulk-sticky-footer');
    if (stickyFooter) {
      document.body.appendChild(stickyFooter);
      document.body.style.paddingBottom = '80px';

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            stickyFooter.classList.add('bulk-sticky-footer--visible');
          } else {
            stickyFooter.classList.remove('bulk-sticky-footer--visible');
          }
        });
      }, { threshold: 0.05 });

      observer.observe(wrapper);
    }

    // ── Init ──────────────────────────────────
    renderTable();
    updateSummary();
    console.log('[Bulk Order v2] Ready —', variants.length, 'variants,', colors.length, 'colors');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// Κρύβει MultiVariants με JS
function hideMultivariants() {
  const ids = [
    'MULTIVARIANTS_APP_SECTION_PLACE',
    'multivariants_setbox_package',
    'multivariants_setbox_header',
    'multivariants_setbox_body',
    'multivariants_setbox_footer',
    'MULTIVARIANTS_APP_BLOCK_CONTENT'
  ];
  ids.forEach(id => {
    const el = document.getElementById(id);
    if (el) el.style.setProperty('display', 'none', 'important');
  });
}

hideMultivariants();
setTimeout(hideMultivariants, 500);
setTimeout(hideMultivariants, 1500);
setTimeout(hideMultivariants, 3000);
